import * as React from "react";

interface IProps {
  width: number;
  height: number;
  updateCanvas: (context: CanvasRenderingContext2D) => void;
}

interface IState extends React.ComponentState {
  image?: HTMLImageElement;
}

export default class Canvas extends React.Component<IProps, IState> {
  private canvas: HTMLCanvasElement;

  public componentDidMount() {
    this.updateCanvas();
  }

  public componentWillReceiveProps(nextProps: IProps) {
    this.updateCanvas();
  }

  public componentDidUpdate() {
    this.updateCanvas();
  }

  public updateCanvas(shouldClear: boolean = false) {
    const context = this.canvas.getContext("2d") as CanvasRenderingContext2D;

    if (shouldClear) {
      context.clearRect(0, 0, this.props.width, this.props.height);
    }

    this.props.updateCanvas(context);
  }

  public render() {
    return (
      <canvas
        {...this.props}
        ref={element => {
          this.canvas = element!;
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/canvas.tsx